import React from 'react';
import { Button } from 'antd';
import type { CSSProperties } from 'react';
import { LoadingOutlined } from '@ant-design/icons';

import { TPO_OPTIMIZE_CANCEL_BTN, TPO_OPTIMIZE_RUN_BTN, TPO_OPTIMIZE_STATUS } from '../../../../config/testIds';

const CANCEL_BTN_STYLE: CSSProperties = { borderRadius: 6, borderColor: '#44338a', color: '#44338a' };
const RUN_BTN_STYLE: CSSProperties = { borderRadius: 8, minWidth: '140px' };

const STATUS_SPINNER = <LoadingOutlined style={{ fontSize: 14 }} spin />;

interface OptimizePlanFooterProps {
    statusMessage?: string;
    cancelLabel: string;
    runLabel: string;
    runDisabled: boolean;
    onCancel: () => void;
    onRun: () => void;
}

const OptimizePlanFooter: React.FC<OptimizePlanFooterProps> = ({
    statusMessage,
    cancelLabel,
    runLabel,
    runDisabled,
    onCancel,
    onRun,
}) => (
    <div className="flex items-center justify-end">
        {statusMessage != null ? (
            <span
                className="mr-auto flex items-center gap-2 text-sm text-[#52525c]"
                data-testid={TPO_OPTIMIZE_STATUS}
            >
                {STATUS_SPINNER}
                {statusMessage}
            </span>
        ) : null}
        <Button style={CANCEL_BTN_STYLE} onClick={onCancel} data-testid={TPO_OPTIMIZE_CANCEL_BTN}>
            {cancelLabel}
        </Button>
        <Button
            type="primary"
            style={RUN_BTN_STYLE}
            disabled={runDisabled}
            onClick={onRun}
            data-testid={TPO_OPTIMIZE_RUN_BTN}
            data-state-disabled={runDisabled ? 'true' : undefined}
        >
            {runLabel}
        </Button>
    </div>
);

OptimizePlanFooter.displayName = 'OptimizePlanFooter';
export default React.memo(OptimizePlanFooter);
